// extracted by mini-css-extract-plugin
export default {"formContainer":"formContainer__ZTg1Z","inputsWrapper":"inputsWrapper__M2Y1N","verticalStack":"verticalStack__ZGNiO","ctaWrapper":"ctaWrapper__OGUwN"};